import { Field } from 'formik';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import { IField, RadioOption } from '../interfaces/IField';

export const RadioField = (props: IField) => (
	<>
		{props.options &&
			props.options.map((option: string | RadioOption, index) => {
				const optionValue = typeof option === 'object' ? option.value : option;
				const optionLabel = typeof option === 'object' ? option.label : option;
				const isDisabledOption = props.disabled && optionValue === 'true';
				const tooltipId = `${props.name}-${optionValue}-tooltip`;

				return (
					<span
						key={optionLabel}
						className={`ml-2 text-sm font-medium ${
							props.disabled
								? 'text-gray-400 cursor-not-allowed'
								: 'text-gray-900'
						}`}
					>
						<Field
							value={optionValue}
							className={`mr-1 ${props.disabled ? 'cursor-not-allowed' : ''}`}
							data-test={`${props.name}-${optionLabel}`}
							data-tooltip-id={isDisabledOption ? tooltipId : undefined}
							{...props}
							id={`${props.name}${index === 0 ? '' : index}`}
							disabled={props.disabled}
						/>
						<span
							data-tooltip-id={isDisabledOption ? tooltipId : undefined}
							className={isDisabledOption ? 'cursor-help' : ''}
						>
							{optionLabel}
						</span>
						{isDisabledOption && (
							<ReactTooltip
								id={tooltipId}
								place="top"
								content={`This feature is NOT available for Emerald users.
										Please upgrade your plan to access this feature.`}
								style={{ whiteSpace: 'pre-line' }}
							/>
						)}
					</span>
				);
			})}
	</>
);
